import {
    TableViewStore,
    BaseListViewStore
} from 'core/stores';
import applicationContext from 'core/utils/applicationContext';
import { VendorsService } from 'application/vendors/services';
import { resolveColumns } from 'application/facility/util/resolveColumns';
import { action } from 'mobx';

@applicationContext
class VendorsListViewStore extends BaseListViewStore {
    constructor(rootStore) {
        const service = new VendorsService(rootStore.application.baasic.apiClient);
        super(rootStore, {
            name: 'vendors',
            autoInit: true,
            authorization: {
                create: 'portalSection.create',
                delete: 'portalSection.delete',
            },
            routes: {
                create: () => this.rootStore.routerStore.goTo(
                    'master.app.main.vendors.create'
                ),
                edit: item => {
                    this.setChildNavigationTitle(i =>
                        i.id === item.id,
                        () => item.name
                    );
                    return this.rootStore.routerStore.goTo(
                        'master.app.main.vendors.edit',
                        { id: item.id }
                    )
                },
            },
            actions: () => {
                return {
                    find: async (params) => {
                
                    const sortParam = params.orderBy && params.orderDirection
                        ? `${params.orderBy}|${params.orderDirection}`
                        : 'name|asc'
                  
                    const response = await service.find({
                        ...params,
                        sort: sortParam
                    })
                                    
                        return response.data;
                    },
                    delete: async (item) => {
                        await service.delete(item);
                    }
                }
            }
        });

        this.setTableStore(new TableViewStore(this.queryUtility, {
            columns: resolveColumns([
                {
                    key: 'name',
                    title: 'VENDORS.LIST.COLUMNS.NAME',
                },
            ]),
            actions: {
                onEdit: async (item) => this.routes.edit(item),
                onDelete: async (item) => this.deleteResource(item),
            }
        }));
    }

    @action.bound
    notifySuccessDelete() {
        this.rootStore.notificationStore.success('VENDORS.LIST.ACTIONS.SUCCESS_DELETE');
    }
}

export default VendorsListViewStore;
